/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner
 */
export interface GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner {
    /**
     * 
     */
    uuid?: string;
    /**
     * 
     */
    clientRef?: string;
    /**
     * 
     */
    mode?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    location?: string;
    /**
     * 
     */
    billingCycle?: string;
    /**
     * 
     */
    reportedEmployeeCount?: number;
    /**
     * 
     */
    subscriptionStart?: string | null;
    /**
     * 
     */
    subscriptionEnd?: string | null;
}

/**
 * Check if a given object implements the GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner interface.
 */
export function instanceOfGetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner(value: object): value is GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner {
    return true;
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerFromJSON(json: any): GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner {
    return GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerFromJSONTyped(json, false);
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'clientRef': json['clientRef'] == null ? undefined : json['clientRef'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'name': json['name'] == null ? undefined : json['name'],
        'location': json['location'] == null ? undefined : json['location'],
        'billingCycle': json['billingCycle'] == null ? undefined : json['billingCycle'],
        'reportedEmployeeCount': json['reportedEmployeeCount'] == null ? undefined : json['reportedEmployeeCount'],
        'subscriptionStart': json['subscriptionStart'] === undefined ? undefined : json['subscriptionStart'] === null ? null : json['subscriptionStart'],
        'subscriptionEnd': json['subscriptionEnd'] === undefined ? undefined : json['subscriptionEnd'] === null ? null : json['subscriptionEnd'],
    };
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerToJSON(json: any): GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner {
    return GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerToJSONTyped(json, false);
}

export function GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInnerToJSONTyped(value?: GetAllServiceProviders200ResponseServiceProvidersInnerClientsAuditInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'clientRef': value['clientRef'],
        'mode': value['mode'],
        'name': value['name'],
        'location': value['location'],
        'billingCycle': value['billingCycle'],
        'reportedEmployeeCount': value['reportedEmployeeCount'],
        'subscriptionStart': value['subscriptionStart'],
        'subscriptionEnd': value['subscriptionEnd'],
    };
}

